import { Checkbox } from 'antd';
import { t } from '../../../i18n/i18n';
import DropDownSelect from '../../DropdownSelect/DropdownSelect';
import TestGroupsItem from '../../TestGroupsItem/TestGroupsItem';

export const TestGroupDifficultyConfig = ({
  testGroupQuantityQuestions,
  setTestGroupQuantityQuestions,
  onBlurInputNumber,
  handleSelectDifficulty,
  testGroupDifficult,
  testDifficulty,
  availableThemes,
  handleSelectTheme,
  testGroupTheme,
  testgroupWithThemes,
  testGroupListeningTest,
  handleAudioDifficulty,
  handleCreateQuestionsSet,
  disabledCreateSet,
  testGroupQuestions,
  setShow,
  setItemDelete,
  handleOrderSetQuestions,
  readOnly = false,
}) => (
  <div>
    <div className="my-2 my-sm-0 mr-0 mr-sm-2 pr-md-5 mr-md-5 mx-4 d-flex align-items-center w-60">
      <span className=" font-weight-600 text-muted font-italic text-xs pr-0 text-nowrap">
        {t('CREATE_TEST_GROUP_QUANTITY_TESTS')}
      </span>
      <input
        className="ml-2 border-thin-blue-principal font-weight-bold  py-1 max-char-input-create-testgroup px-2 outline-none h-25 col-1"
        type="number"
        onKeyDown={(e) => {
          const excludedKeys = ['e', '+', '-', '.'];
          if (excludedKeys.includes(e.key)) {
            e.preventDefault();
          }
        }}
        value={testGroupQuantityQuestions ?? ''}
        name="weight"
        onChange={(e) => {
          setTestGroupQuantityQuestions(e.target.value);
        }}
        onBlur={(e) => {
          onBlurInputNumber(e);
        }}
        disabled={readOnly}
      />
      <DropDownSelect
        selectedPlaceholder
        className="mx-3 py-0"
        placeholder={t('MULTIPLE_SELECT_DIFFICULTY_PLACEHOLDER')}
        setState={handleSelectDifficulty}
        selected={testGroupDifficult}
        disabled={readOnly}
        options={testDifficulty
          ?.sort((a, b) => a.order - b.order)
          ?.map((item) => ({
            id: item.id,
            name: t(`CREATE_TEST_GROUP_QUESTION_${item.name}`),
            key: item.id,
          }))}
      />
      {testgroupWithThemes && (
        <DropDownSelect
          selectedPlaceholder
          className="mx-3 py-0"
          placeholder={t('ABM_THEME_INPUT_PLACEHOLDER')}
          disabled={!availableThemes.length || readOnly}
          setState={handleSelectTheme}
          selected={testGroupTheme}
          options={availableThemes?.map((item) => ({
            id: item,
            name: item,
            key: item.id,
          }))}
        />
      )}
      <div
        data-testid="difficulty-config-with-audio-container"
        className="d-flex align-items-center mr-4"
      >
        <Checkbox
          testid="difficulty-config-with-audio-checkbox"
          checked={testGroupListeningTest}
          onClick={handleAudioDifficulty}
          disabled={readOnly}
          className="test-checkbox align-self-start d-flex align-items-center justify-content-between"
        />
        <span
          data-testid="difficulty-config-with-audio-checkbox-text"
          className=" text-nowrap ml-2 font-weight-500 text-xs"
        >
          {t('TESTGROUP_ABM_QUESTION_WITH_AUDIO')}
        </span>
      </div>
      <button
        onClick={handleCreateQuestionsSet}
        disabled={disabledCreateSet || readOnly}
        className={`px-4 py-1 rounded-pill  text-white text-xs font-weight-bold border-0 outline-none ${
          disabledCreateSet ? 'disabled-button' : 'bg-maya-blue'
        }`}
        type="button"
      >
        {t('CREATE_TEST_GROUP_CREATE_BUTTON')}
      </button>
    </div>
    <div className="my-3">
      {testGroupQuestions
        ?.sort((a, b) => a.order - b.order)
        ?.filter((item) => (testgroupWithThemes ? item.theme : !item.theme))
        ?.map((item, index) => (
          <TestGroupsItem
            key={item.ordererId}
            disabled={readOnly}
            test={{
              text: `${item.quantity} ${
                Number(item.quantity) === 1
                  ? t('CREATE_TEST_GROUP_QUESTION')
                  : t('CREATE_TEST_GROUP_QUESTIONS')
              }`,
              questionDifficulty: t(
                `CREATE_TEST_GROUP_QUESTION_${
                  testDifficulty.find((d) => d.id === item.difficultyId)?.name || 'NOT_DIFFICULTY'
                }`
              ),
              order: index,
              theme: item?.theme,
              listeningTest: item?.listeningTest,
              langDisplayName: item?.langDisplayName,
            }}
            handleDelete={() => {
              setShow(true);
              setItemDelete({
                text: `${item.quantity} ${
                  Number(item.quantity) === 1
                    ? t('CREATE_TEST_GROUP_QUESTION')
                    : t('CREATE_TEST_GROUP_QUESTIONS')
                }`,
                id: item.ordererId,
                isDifficulty: true,
              });
            }}
            handleOrder={handleOrderSetQuestions}
            disableOrderUp={index === 0}
            disableOrderDown={index === testGroupQuestions.length - 1}
            testGroupABM
          />
        ))}
    </div>
  </div>
);
